/**
 * Image Material Component
 *
 * Displays image materials with download protection.
 */

import { useTranslation } from 'react-i18next';
import { getLocalizedTitle, useMaterialUrl, type Material } from '@immopersian/common';
import { LoadingSpinner } from './shared/LoadingSpinner';
import { ErrorMessage } from './shared/ErrorMessage';
import { MaterialDescription } from './shared/MaterialDescription';

interface ImageMaterialProps {
  material: Material;
}

export function ImageMaterial({ material }: ImageMaterialProps) {
  const { t, i18n } = useTranslation();
  const { data, isLoading, error } = useMaterialUrl(material.id, material.type);

  if (isLoading) {
    return <LoadingSpinner message={t('courses.loadingImage')} />;
  }

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <>
      <div
        className="rounded-lg overflow-hidden border border-brand-beige"
        data-protected
        onContextMenu={(e) => e.preventDefault()}
      >
        <img
          src={data?.url || ''}
          alt={getLocalizedTitle(material, i18n.language)}
          className="w-full h-auto pointer-events-none"
          draggable={false}
          onDragStart={(e) => e.preventDefault()}
        />
      </div>
      <MaterialDescription material={material} />
    </>
  );
}
